<div class="comment-panel">
  <div>
    <ng-content></ng-content>
  </div>
  @if (showCommentsLink()) {
  <div class="comment-icon" [routerLink]="getCommentsLink()">
    <i class="material-icons icon">message</i>
  </div>
  } @else {
  <div class="comment-icon add-comment-icon" (click)="showAddComment()">
    <i class="material-icons icon">add_comment</i>
  </div>
  }
</div>
